import { gql } from '@apollo/client';

export type TmsTaskItem = {
  id: number;
  taskSource: number | null;
  taskNumber: string | null;
  taskType: number | null;
  businessType: number | null;
  taskDate: string | null;
  taskStatus: number | null;
  bolNumber: string | null;
  routeId: number | null;
  scheduleId: number | null;
  routeName: string | null;
  routeType: number | null;
  routeCode: string | null;
  warehouseId: number | null;
  warehouseName: string | null;
  planDepartureAt: string | null;
  planDepartureLocalAt: string | null;
  planDepartureTimezone: string | null;
  actualDepartureAt: string | null;
  actualDepartureLocalAt: string | null;
  actualDepartureTimezone: string | null;
  planArrivalAt: string | null;
  planArrivalLocalAt: string | null;
  planArrivalTimezone: string | null;
  actualArrivalAt: string | null;
  actualArrivalLocalAt: string | null;
  actualArrivalTimezone: string | null;
  carrierId: number | null;
  vehicleId: number | null;
  vehicleTypeId: number | null;
  licensePlate: string | null;
  trailerNumber: string | null;
  publishedAt: string | null;
  completedAt: string | null;
  remark: string | null;
  isDeleted: boolean;
  createdAt: string | null;
  updatedAt: string | null;
};

export type TmsTaskFilter = {
  id?: number;
  taskNumber?: string;
  routeId?: number;
  taskStatus?: number;
  taskType?: number;
  businessType?: number;
  taskDateFrom?: string;
  taskDateTo?: string;
  isDeleted?: number;
};

export type PagedResult<T> = {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
};

export type TmsTasksResponse = {
  opsToolTmsTasks: PagedResult<TmsTaskItem>;
};

export const TMS_TASKS = gql`
  query OpsToolTmsTasks($filter: OpsTmsTaskFilterInput!, $pageRequest: PageRequestTypeInput) {
    opsToolTmsTasks(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        taskSource
        taskNumber
        taskType
        businessType
        taskDate
        taskStatus
        bolNumber
        routeId
        scheduleId
        routeName
        routeType
        routeCode
        warehouseId
        warehouseName
        planDepartureAt
        planDepartureLocalAt
        planDepartureTimezone
        actualDepartureAt
        actualDepartureLocalAt
        actualDepartureTimezone
        planArrivalAt
        planArrivalLocalAt
        planArrivalTimezone
        actualArrivalAt
        actualArrivalLocalAt
        actualArrivalTimezone
        carrierId
        vehicleId
        vehicleTypeId
        licensePlate
        trailerNumber
        publishedAt
        completedAt
        remark
        isDeleted
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export type TmsTaskWaypointItem = {
  id: number;
  taskId: number | null;
  waypointId: number | null;
  extWaypointId: number | null;
  routeId: number | null;
  waypointOrder: number | null;
  waypointType: number | null;
  waypointStatus: number | null;
  planDepartureAt: string | null;
  planDepartureLocalAt: string | null;
  planDepartureTimezone: string | null;
  actualDepartureAt: string | null;
  actualDepartureLocalAt: string | null;
  actualDepartureTimezone: string | null;
  planArrivalAt: string | null;
  planArrivalLocalAt: string | null;
  planArrivalTimezone: string | null;
  actualArrivalAt: string | null;
  actualArrivalLocalAt: string | null;
  actualArrivalTimezone: string | null;
  loadingTime: string | null;
  parcelCount: number | null;
  bagCount: number | null;
  sealNumber: string | null;
  sealTime: string | null;
  unSealTime: string | null;
  departureRemark: string | null;
  arrivedRemark: string | null;
  zone: string | null;
  waypointName: string | null;
  staticEtaAt: string | null;
  staticEtaLocalAt: string | null;
  staticEtaTimezone: string | null;
  unLoadingTime: string | null;
  loadingInfoRemark: string | null;
  bolRemark: string | null;
  sealAccountId: number | null;
  unSealAccountId: number | null;
  arrivalPhotoKeys: string[];
  arrivalPhotoUrls: string[];
  arrivalSealPhotoKeys: string[];
  arrivalSealPhotoUrls: string[];
  loadingInteriorPhotoKeys: string[];
  loadingInteriorPhotoUrls: string[];
  departurePhotoKeys: string[];
  departurePhotoUrls: string[];
  departureSealPhotoKeys: string[];
  departureSealPhotoUrls: string[];
  unSealInteriorPhotoKeys: string[];
  unSealInteriorPhotoUrls: string[];
  bolPhotoKeys: string[];
  bolPhotoUrls: string[];
  isDeleted: boolean;
  createdAt: string | null;
  updatedAt: string | null;
};

export type TmsTaskWaypointsResponse = {
  opsToolTmsTaskWaypoints: TmsTaskWaypointItem[];
};

export const TMS_TASK_WAYPOINTS = gql`
  query OpsToolTmsTaskWaypoints($taskId: Long!) {
    opsToolTmsTaskWaypoints(taskId: $taskId) {
      id
      taskId
      waypointId
      extWaypointId
      routeId
      waypointOrder
      waypointType
      waypointStatus
      planDepartureAt
      planDepartureLocalAt
      planDepartureTimezone
      actualDepartureAt
      actualDepartureLocalAt
      actualDepartureTimezone
      planArrivalAt
      planArrivalLocalAt
      planArrivalTimezone
      actualArrivalAt
      actualArrivalLocalAt
      actualArrivalTimezone
      loadingTime
      parcelCount
      bagCount
      sealNumber
      sealTime
      unSealTime
      departureRemark
      arrivedRemark
      zone
      waypointName
      staticEtaAt
      staticEtaLocalAt
      staticEtaTimezone
      unLoadingTime
      loadingInfoRemark
      bolRemark
      sealAccountId
      unSealAccountId
      arrivalPhotoKeys
      arrivalPhotoUrls
      arrivalSealPhotoKeys
      arrivalSealPhotoUrls
      loadingInteriorPhotoKeys
      loadingInteriorPhotoUrls
      departurePhotoKeys
      departurePhotoUrls
      departureSealPhotoKeys
      departureSealPhotoUrls
      unSealInteriorPhotoKeys
      unSealInteriorPhotoUrls
      bolPhotoKeys
      bolPhotoUrls
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

export type TmsTaskWaypointContainerItem = {
  id: number | null;
  containerType: number | null;
  containerCount: number | null;
  sortingCode: string | null;
  destinationWarehouseId: number | null;
  destinationWarehouseName: string | null;
};

export type TmsTaskWaypointLoadingItem = {
  loadingDetailId: number | null;
  bagId: number | null;
  bagNumber: string | null;
  trackingNumber: string | null;
  sortingCode: string | null;
  destinationWarehouseId: number | null;
  destinationWarehouseName: string | null;
  parcelQuantity: number | null;
  status: number | null;
  loadingTime: string | null;
  createdAt: string | null;
};

export type TmsTaskWaypointLoadingSummaryResponse = {
  opsToolTmsTaskWaypointLoadingSummary: {
    totalParcelQuantity: number;
    totalBagQuantity: number;
    totalContainerQuantity: number;
    containers: TmsTaskWaypointContainerItem[];
    details: TmsTaskWaypointLoadingItem[];
  };
};

/** 途经点「装车信息」只读汇总：装载明细 + 装车容器原始行 */
export const TMS_TASK_WAYPOINT_LOADING_SUMMARY = gql`
  query OpsToolTmsTaskWaypointLoadingSummary($taskId: Long!, $taskWaypointId: Long!) {
    opsToolTmsTaskWaypointLoadingSummary(taskId: $taskId, taskWaypointId: $taskWaypointId) {
      totalParcelQuantity
      totalBagQuantity
      totalContainerQuantity
      containers { id containerType containerCount sortingCode destinationWarehouseId destinationWarehouseName }
      details { loadingDetailId bagId bagNumber trackingNumber sortingCode destinationWarehouseId destinationWarehouseName parcelQuantity status loadingTime createdAt }
    }
  }
`;
